module.exports = __webpack_public_path__ + "static/media/change-pw-graphic.8f25584a.png";